module.exports = __webpack_public_path__ + "img/accumap_text.e4321d82.svg";